
const ERNST_TOKEN_UAT = "F76EF53BCB522BB18C7AEE6D60F9219652E9BE068917F4919BC213467039C10F";
const ERNST_TOKEN_PROD = "06862D1B956138BD73950EDF04CBBAFBAF9DA40A7F61C53FDBFF35DE74FF2489"

export default class appConfig {

    static ernstIframeUrl(): string {        
        return process.env.NODE_ENV === "production" ? `https://whitelabel.p1.ernst.bkicloud.com/${ERNST_TOKEN_PROD}` : `https://whitelabel.u1.ernst.bkicloudtest.com/${ERNST_TOKEN_UAT}`
    }
}